import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector"; // Optional: if you want to detect the user's language

import en from "./locales/en.json";
import ar from "./locales/ar.json";

i18n
  .use(LanguageDetector) // Optional: detect user language
  .use(initReactI18next)
  .init({
    resources: {
      en: { ...en },
      ar: { ...ar },
    },
    detection: {
      order: ["localStorage", "cookie", "htmlTag", "path", "subdomain"],
      caches: ["localStorage", "cookie"],
    },
    fallbackLng: "ar",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
